import moment from 'moment';

const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const getSlotsRange = (slot) => {
  let initialHour = moment().set('hour', '00').set('minute', '00');
  const currentDay = initialHour.date();
  const hours = [];
  while (currentDay === initialHour.date()) {
    hours.push(initialHour.format('HH:mm'));
    initialHour.add(slot, 'minute');
  }
  return hours;
};

const mobileScreen = () => {
  return window.innerWidth <= 900;
};

const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const isOlderThan18 = (dateOfBirth) => {
  const today = moment();

  const diff = today.diff(moment(dateOfBirth, 'DD/MM/YYYY'), 'years');

  return diff >= 18;
};

function removeAccents(texto) {
  return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function formatNumber(number) {
  let formatter = new Intl.NumberFormat('es-UY', {
    currency: 'UYU',
    maximumFractionDigits: 1,
  });
  return formatter.format(number);
}
function roundOutNumber(number) {
  var decimal = number - Math.floor(number);
  if (decimal >= 0.5) {
    return Math.ceil(number);
  } else {
    return Math.floor(number);
  }
}

function roundUp(number) {
  return (Math.round(number * 100) / 100).toFixed(1);
}

export {
  capitalize,
  getSlotsRange,
  mobileScreen,
  validateEmail,
  isOlderThan18,
  removeAccents,
  formatNumber,
  roundOutNumber,
  roundUp,
};
